import { Directive, HostListener, inject } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appTrimOnBlur]',
})
export class TrimOnBlurDirective {
  private ngControl = inject(NgControl);

  @HostListener('blur', ['$event.target.value'])
  public onBlur(value: string) {
    if (this.ngControl.control) {
      this.ngControl.control.patchValue(value.trim());
    }
  }
}
